<dx-data-grid #batchReportsGrid
  id="gridContainer"
  [dataSource]="jobGroups"
  [repaintChangesOnly]="true" 
  [showBorders]="true"
  (onRowExpanding)="onRowExpanding($event)"  
  (onRowClick)="onRowClicked($event)">  
  <dxo-selection mode="single"></dxo-selection>
  <dxi-column dataField="reportRefID" caption="Report Reference #" [width]="300"></dxi-column>
  <dxi-column dataField="requestedDateTime" caption="Requested Date & Time" dataType="datetime" [width]="180"></dxi-column>  
  <dxi-column dataField="reportType" caption="Report Type"></dxi-column>
  <dxi-column dataField="statusSummary" caption="Status Summary"></dxi-column>
  <dxi-column
      type="selection" [width]="250"
      cellTemplate="selectionCellTemplate"
      headerCellTemplate="selectionHeaderCellTemplate">
  </dxi-column>
  <div *dxTemplate="let cellInfo of 'selectionCellTemplate'">
      <a href="javascript:void(0);" (click)="onViewClicked(cellInfo)" [class.disable-link]="disableViewReport(cellInfo)">View Reports</a>
      &nbsp;|&nbsp;
      <a href="javascript:void(0);" (click)="onViewReqParamsClicked(cellInfo)">Report Parameters</a>
  </div>
  <div *dxTemplate="let headerInfo of 'selectionHeaderCellTemplate'">
      Actions
  </div>
  <dxo-master-detail [enabled]="false" template="detail"></dxo-master-detail>
  <dxo-paging [enabled]="true" [pageSize]="actualPageSize"></dxo-paging>
  <dxo-pager [visible]="true" [showPageSizeSelector]="false"
        [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>      
  <div *dxTemplate="let jobGroup of 'detail'">    
    <app-detail-grid [key]="jobGroup.key" [reportType]="reportType" (batchGridEvent)="onDetailGridEvent($event)"></app-detail-grid>
  </div>
  <dxo-load-panel shadingColor="rgba(0,0,0,0.4)" [showPane]="true" [shading]="false"></dxo-load-panel>

</dx-data-grid>
<dx-popup
  [width]="680"
  [height]="500"
  [showTitle]="true"
  [title]="'Report Request Parameters'"
  [dragEnabled]="false"    
  [showCloseButton]="true"
  [(visible)]="reqParamsPopupVisible"
  (onShowing)="onPopupShowing($event)">        
      <div id="reqparams-popup-content" style="height: auto;" *dxTemplate="let data of 'content'">            
          <dx-data-grid id="popupGridContainer"
              [dataSource]="requestParamsData"                
              keyExpr="paramName"
              [height]="'95%'"
              [allowColumnReordering]="true"
              [showRowLines]="true"
              [showColumnLines]="true"
              [showBorders]="true"
              [columnAutoWidth]="true"
              [rowAlternationEnabled]="true"
              [columnHidingEnabled]="false"
              [allowColumnResizing]="true"
              [paging.pageIndex]="0"
              (onContentReady)="onReqParamGridReady($event)">

              <dxo-filter-row [visible]="false"></dxo-filter-row>
              <dxo-header-filter [visible]="false"></dxo-header-filter>                                
              <dxo-filter-panel [visible]="false"></dxo-filter-panel>
              <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>                
              <dxo-pager
                  [visible]="true"
                  [allowedPageSizes]="allowedPageSizes"
                  [showPageSizeSelector]="false"
                  [showInfo]="true"
                  [showNavigationButtons]="false">
              </dxo-pager>            
              <dxo-column-fixing [enabled]="true"></dxo-column-fixing>            
              <div *dxTemplate="let info of 'boldHeaderTemplate'">
                  <b>{{info.column.caption}}</b>
              </div>
              <dxi-column dataField="paramName" headerCellTemplate="boldHeaderTemplate" [width]="200" caption="Request Parameter"></dxi-column>
              <dxi-column dataField="paramValue" headerCellTemplate="boldHeaderTemplate" [width]="400" caption="Value"></dxi-column>                                           
          </dx-data-grid>            
      </div>
</dx-popup>
